module.exports = __webpack_public_path__ + "static/img/index2(1)_13.3db717f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index2(1)_13.png
// module id = 3124
// module chunks = 1